import { render, staticRenderFns } from "./OptionDetail.vue?vue&type=template&id=449f54ac"
import script from "./OptionDetail.vue?vue&type=script&lang=js"
export * from "./OptionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports